import { useDispatch } from "react-redux";
import styled from "styled-components";
import { BASIC_DARK_GRAY, BASIC_LINE } from "../../../constants/colors";
import { appActions } from "../../../ducks/app";
import { useAsset } from "../../../hooks/useAsset";
import { Button } from "../../atoms/Button";

type Props = {
  name: string;
  address: string;
  phoneNumber: string;
  service: string;
  location: { lat: number; lng: number };
  isFavorite: boolean;
  onFavorite: (favorite: boolean) => void;
  onDelete: () => void;
  onClosePopup: () => void;
};

export const FavoriteStoreItem: React.FC<Props> = ({
  name,
  address,
  phoneNumber,
  service,
  location,
  isFavorite,
  onFavorite,
  onDelete,
  onClosePopup,
}) => {
  const dispatch = useDispatch();

  const { baseDir } = useAsset();

  return (
    <>
      <FavoriteStoreItemContainer
        onClick={() =>
          dispatch(
            appActions.showStoreDetailPopup.started({
              name,
              address,
              phoneNumber,
              service,
              location,
              isFavorite,
              onFavorite: (favorite) => {
                onFavorite(favorite);
                dispatch(appActions.setStoreDetailPopupFavorite(favorite));
              },
              onClose: () => {
                onClosePopup();
                dispatch(appActions.closeStoreDetailPopup());
              },
            }),
          )
        }
      >
        <IconContainer
          style={{
            backgroundImage: `url('${baseDir}/assets/images/icons/ico_shop01.png')`,
          }}
        />
        <ShopInfoWrapper>
          <ShopName>{name}</ShopName>
          <ShopAddress>{address}</ShopAddress>
        </ShopInfoWrapper>
        <ButtonWrapper>
          <Button
            btnStyle="secondary"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            text="削除"
            size="xxs"
            rounded="sm"
          />
        </ButtonWrapper>
      </FavoriteStoreItemContainer>
    </>
  );
};

const FavoriteStoreItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: 20px;
  margin: 0 0 23px 0;
  border-bottom: 1px solid ${BASIC_LINE};
`;

const IconContainer = styled.div`
  background-size: contain;
  width: 28px;
  height: 26px;
  margin: 0 24px 0 0;
`;

const ShopInfoWrapper = styled.div`
  flex: 1;
  text-align: left;
`;

const ShopName = styled.p`
  color: ${BASIC_DARK_GRAY};
  font-size: 20px;
  font-weight: 600;
  padding: 0;
  margin: 0 0 3px 0;
  line-height: 1;
`;

const ShopAddress = styled.p`
  font-family: "Hiragino Sans";
  color: ${BASIC_DARK_GRAY};
  font-size: 14px;
  font-weight: 700;
  padding: 0;
  margin: 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    font-size: 16px;
    padding: 10px 12px;
    width: auto;
  }
`;
